import React from "react";
import Calculator from "./calculator";
import { formatNumber } from "../../../../middleware/common-functions";
import { OrderType } from "../../../../models/order_model";
import { CalculatorItem } from "../../../../models/calculator_model";

type PayOutProps = {
  order: OrderType;
  addUp: any;
  calculator: CalculatorItem;
  payOutBack: any;
  payOrder: any;
  shake: boolean;
  setPaymentType: any;
  tip: string;
  handleTipChange: (value: string) => void;
  tipFocused: boolean;
  setTipFocused: (focused: boolean) => void;
};

const PayOut: React.FC<PayOutProps> = ({
  order,
  addUp,
  calculator,
  payOutBack,
  payOrder,
  shake,
  setPaymentType,
  tip,
  handleTipChange,
  tipFocused,
  setTipFocused,
}) => {
  const tipValue = parseFloat(tip) || 0;
  const grandTotal = order.total + tipValue;
  return (
  <div className="container-fluid py-2">
    <div className="row charge_div">
      <div className="col p-1">
        <div className="d-flex align-items-center justify-content-center">
          <h5 className="fa-2x text_blue m-0">
            Total: <b>${formatNumber(order.total)}</b>
          </h5>
          <div className="d-flex align-items-center ml-3">
            <label className="m-0 mr-2">Propina:</label>
            <input
              type="text"
              className={`form-control form-control-sm ${tipFocused ? 'border-primary' : ''}`}
              style={{ width: "100px" }}
              value={tip}
              onChange={(e) => handleTipChange(e.target.value)}
              onFocus={() => setTipFocused(true)}
              onBlur={() => setTipFocused(false)}
              placeholder="$0"
            />
          </div>
          {tipValue > 0 && (
            <h5 className="m-0 ml-3">
              Gran Total: <b>${formatNumber(grandTotal)}</b>
            </h5>
          )}
          <h5 className="m-0 ml-3">Movimientos</h5>
        </div>

        <hr className="my-1" />

        <h6 className="text-center mb-0">Monto</h6>
        <h5 className="my-1 fa-2x text-center">
          $<span className="cash">{calculator.amount || 0}</span>
        </h5>
        {calculator.cash_diff ? (
          <h6
            className={`text-center ${
              calculator.cash_diff > 0 ? "text-muted" : "text-success"
            } ${shake ? "shake_anim" : ""}`}
          >
            <span id="cash_left_txt">
              {calculator.cash_diff > 0 ? "Restante" : "Cambio"}
            </span>
            : $
            <span className="cash_left">
              {formatNumber(
                calculator.cash_diff > 0
                  ? calculator.cash_diff
                  : -calculator.cash_diff,
              )}
            </span>
          </h6>
        ) : null}
        <div className="alert alert-warning text-center d-none" role="alert">
          <h4 className="alert-heading">
            <i className="fas fa-exclamation"></i> Efectivo Insuficiente!
          </h4>
        </div>
      </div>
    </div>
    <Calculator
      addUp={addUp}
      payOutBack={payOutBack}
      payOrder={payOrder}
      type={order.payment_type}
      card_type={order.card_type}
      setPaymentType={setPaymentType}
      ready={
        calculator.amount
          ? (!calculator.cash_diff && calculator.cash_diff !== 0) ||
            calculator.cash_diff > 0
            ? false
            : true
          : true
      }
      charge_total={calculator.amount ? false : true}
    />
  </div>
  );
};

export default PayOut;
